export const version = 'kunde-v1.20.0-SNAPSHOT-80439e2aab8cba8d0a49d0a32949e1a97a2ff677';